import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MenuItem} from 'primeng/api';
import {CommonService} from '../../@shared/services/common.service';
import {CacheService} from '../../@shared/services/cache.service';
import {environment} from '../../../environments/environment';
import {InvoiceAndSoaService} from '../../@shared/new-services/invoice-and-soa.service';
import {UserMgmtService} from '../../@shared/new-services/user-mgmt.service';

@Component({
    selector: 'soa-filters',
    templateUrl: './soa-filters.component.html',
    styleUrls: ['./soa-filters.component.scss']
})
export class SoaFiltersComponent implements OnInit {

    @Input() clearFilter = false;
    @Output() emitFilterValue: EventEmitter<any> = new EventEmitter<any>();

    currency: any = [];
    selectedSOACustomer: string;
    loggedInUser = this.cacheService.retrieveParsedResponse('detailedLoggedInUser');
    isAdmin = false;

    soaFilterForm: FormGroup;
    soaCustomers: any;
    statusFilterOption: MenuItem[] = [
        {
            label: 'Unpaid', command: () => {
                this.setFilterStatus('unpaid');
            }
        },
        {
            label: 'Partially Paid', command: () => {
                this.setFilterStatus('partiallyPaid');
            }
        }
    ];

    constructor(private commonService: CommonService,
                private invoiceAndSoaService: InvoiceAndSoaService,
                private cacheService: CacheService,
                private userMgmtService: UserMgmtService) {
    }

    ngOnInit(): void {
        this.createSoaFilterForm();
        this.loggedInUser?.roles?.map((role) => {
            if (role?.roleId === environment.portalAdminRoleId || role?.roleId === environment.ffAdminRoleId) {
                this.isAdmin = true;
            }
        });
        if (this.isAdmin) {
            this.getSOACustomers();
        }
    }

    // tslint:disable-next-line:use-lifecycle-interface
    ngOnChanges() {
        if (this.clearFilter) {
            this.createSoaFilterForm();
        }
    }

    onSearchOfStatement() {
        this.soaFilterForm.patchValue({
            unPaidBoolean: false,
            partiallyPaidBoolean: false,
            currencyCode: ''
        });

        const filterValue = this.soaFilterForm.value;

        this.emitFilterValue.emit({
            filterValue,
        });
    }

    getSOACustomers() {
        this.userMgmtService
            .getBusinessEntitiesByUser()
            .subscribe((soaCustomers) => {
                this.soaCustomers = soaCustomers;
            });
    }

    createSoaFilterForm() {
        this.soaFilterForm = new FormGroup({
            filterByIdentifier: new FormControl(null),
            unPaidBoolean: new FormControl(false),
            partiallyPaidBoolean: new FormControl(false),
            overDueBoolean: new FormControl(false),
            currencyCode: new FormControl(''),
            businessEntityId: new FormControl(''),
        });
    }

    setFilterStatus(status: string) {
        if (status === 'unpaid') {
            this.soaFilterForm.patchValue({
                unPaidBoolean: true,
                partiallyPaidBoolean: false,
                overDueBoolean: false,
            });
        } else {
            this.soaFilterForm.patchValue({
                unPaidBoolean: false,
                partiallyPaidBoolean: true,
                overDueBoolean: false,
            });
        }

        const filterValue = this.soaFilterForm.value;
        this.emitFilterValue.emit({
            filterValue
        });
    }

    applyCustomerSOAFilter() {
        const filterValue = this.soaFilterForm.value;
        if (filterValue?.businessEntityId === null) {
            filterValue.businessEntityId = '';
        }
        this.emitFilterValue.emit({
            filterValue
        });
    }

}
